import React, { Component } from "react";
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import SearchBar from '../../generics/SearchBar';
import swal from 'sweetalert';
import Table from './components/Table';
import Help from '../../generics/help';

var Config = require('../../../config');

class SampleResults extends Component {
  constructor(props, context) {
    super(props);
    this.getItems = this.getItems.bind(this);

    var aux_date = new Date();
    //Definicion de variables
    this.state = {
      start_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
      end_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
      filterText:"",
      items:[],
      filter_type:"pending",
      filters:[{key:"all", value:"TODOS"}, {key:"pending",value:"PENDIENTES VALIDAR"}, {key:"reject",value:"RECHAZADOS"}, {key:"discrepant",value:"DISCREPANTES"}],
    };
  }

  componentWillMount() {
    setTimeout(function(){
      this.getItems();
    }.bind(this), 100);
  }

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  handleUserInput(filterText) {
    this.setState({filterText: filterText});
  };

  dateHandleChange = (event) => {
    this.setState({date:event.target.value});

    setTimeout(function(){
      this.getItems();
    }.bind(this), 100);
  }

  componentDidUpdate() {
  }

  getItems(){
    if(this.state.start_date !== "" && this.state.end_date !== ""){
      this.waiting_modal.handleShow('Cargando...');
      fetch(Config.default.apiGateway.URL+"samples/filtered?health_facilities_id="+sessionStorage.getItem("health_facilities_id")+
        '&start_date='+this.state.start_date+'&end_date='+this.state.end_date+'&start_folio=&end_folio=&filter='+this.state.filter_type,{ 
          method: 'get',
          headers: new Headers({
             'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
             'Accept': 'application/json',
              'Content-Type': 'application/json',
          })
        })
      .then(res => {
            this.waiting_modal.handleClose();
              if(res.ok){
                return res.json();
              }else{
                res.text().then(function(error) {
                  swal('¡Error!', error, 'error');
                });
            }
        })
      .then(response => {
          if(response !== undefined){
            this.setState({ items: response });
          }
      })
    }else{
      swal('Error', 'Debe seleccionar una fecha', 'error');
    }

      
  }

  //Contenido de la pantalla Listado
  render() {
    const { t } = this.props;

    return (
      <div className="col-xs-12">
        <div className="route">
          <h5 className="title_page" >
            {sessionStorage.getItem('health_facilities_name')} ->
            {t('sidebar.nav.laboratory.MAIN')} -> 
            Resultados Muestras
          </h5>
        </div>
        
        <Help 
          {...this.props}
            menu={"help_laboratory"} 
            submenu={"help_results_samples"}  />

        <div className="col-xs-12">
          <div className="col-xs-12 col-md-2">
            <span className="span-min">{t('content.validation_donation.start_date')+':'}</span>
            <input className="form-control" type="date" value={this.state.start_date} name="start_date" id="start_date" onChange={ this.handleChange}/>
          </div>
          <div className="col-xs-12 col-md-2">
            <span className="span-min">{t('content.validation_donation.end_date')+':'}</span>
            <input className="form-control" type="date" value={this.state.end_date} name="end_date" id="end_date" onChange={ this.handleChange}/>
          </div>
          <div className="col-xs-12 col-md-2">
            <span className="span-min">Estatus:</span> 
            <select className="form-control" onChange={ this.handleChange }
                value={ this.state.filter_type || "" } 
                  name="filter_type" id="filter_type" >
                  {
                  this.state.filters.map(function(t) {
                    return <option key={t.key}  value={t.key} >{t.value} </option>;
                  })
              }
            </select>
          </div>

          <div className="col-xs-12 col-sm-1" style={{paddingTop:"12px"}}>
            <button style={{float:"right", fontSize:"1em"}} className="btn btn-info" type="button" onClick={(e) => this.getItems()}>
              {t('content.generics.buttons.search')}
            </button>
          </div>

          
        </div>
        <div className="col-xs-12 form-group">
          <div className="col-xs-12 col-md-2">
            <span className="span-min">Buscar:</span>
            <SearchBar filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)}/>
          </div>
        </div>
        <div className="col-xs-12">
            <Table filterDate={this.state.date} filterText={this.state.filterText} {...this.props} onRef={ref => (this.table = ref)} 
              items={this.state.items} 
              refresh={this.getItems}
              search={this.props.search} 
              state={this.state}
              />
        </div>
        <Notifications />
        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
      </div>
    );
  }
}

export default translate('translations')(SampleResults)